<!-- 検索バーがあるセレクトボックス -->

<search-select>
  <input class="form-control-search { $clsx(getCurrentLabel()?.startsWith('(NG)') && 'ng-option') }" type="text" value="{ getCurrentLabel() }"
    onclick="{ openMenu }" placeholder="選択" readonly />

  <kf-menu anchor-el="{ state.menu }" open="{ !!state.menu }" on-close="{ closeMenu }" max-height="300">
    <div class="menu-search">
      <form onsubmit="{ e => e.preventDefault() }">
        <input class="form-control" type="text" oninput="{ handleFilterChange }"
          value="{ state.filter }" placeholder="検索" />
      </form>
    </div>
    <label class="menu-item { $clsx(i == state.focusedIndex && 'focus', props.getLabel(item)?.startsWith('(NG)') && 'ng-option') }" each="{ (item, i) in state.filteredList }"
      onmouseenter="{ () => onItemHover(i) }">
      <input style="display: none;" type="checkbox" value="{ props.getId(item) }"
        onchange="{ handleCheckChange }" checked="{ props.getId(item) == props.value }" />
      { props.getLabel(item) }
    </label>
  </kf-menu>
  <script>
    import KfMenu from '@/common/components/kf-menu/kf-menu.riot';
    import { getEventValue } from '@/common/utils/dom';

    export default {
      components: {
        KfMenu,
      },
      state: {
        menu: null,
        filter: '',
        filteredList: [],
        focusedIndex: -1,
      },

      onBeforeMount() {
        this.state.filter = '';
        this.state.menu = null;
        this.state.filteredList = this.props.itemList;
        this.state.focusedINdex = -1;
      },

      onItemHover(i) {
        this.state.focusedIndex = i;
        this.update();
      },

      onKeyDown(e) {
        if (!['ArrowDown', 'ArrowUp', 'Enter'].includes(e.key)) return;

        if (this.state.filteredList.length == 0) return;

        if (e.key == 'Enter') {
          if (this.state.focusedIndex == -1 || this.state.filteredList.length == 0) {
            return;
          }
          const item = this.state.filteredList[this.state.focusedIndex];

          if (item) {
            const itemId = this.props.getId(item);
            if (!this.props.unselectable || this.props.value != itemId) {
              this.props.onChange(itemId);
            } else {
              this.props.onChange('');
            }
            this.closeMenu();
            this.update();
          }
          return;
        }

        if (e.key == 'ArrowDown') {
          if (this.state.focusedIndex == this.state.filteredList.length - 1) {
            this.state.focusedIndex = 0;
          } else {
            this.state.focusedIndex += 1;
          }
        } else if (e.key == 'ArrowUp') {
          if (this.state.focusedIndex <= 0) {
            this.state.focusedIndex = this.state.filteredList.length - 1;
          } else {
            this.state.focusedIndex -= 1;
          }
        }
        const element = this.$$('.menu-item')?.[this.state.focusedIndex];
        element?.scrollIntoView({
          behavior: 'instant',
          block: 'nearest',
        });
        this.update();
      },

      handleFilterChange(e) {
        this.state.filter = getEventValue(e);
        if (this.state.filter == '') {
          this.state.filteredList = this.props.itemList;
        } else {
          this.state.filteredList = this.props.itemList.filter(item => this.props.checkMatch(item, this.state.filter));
        }
        this.state.focusedIndex = (this.state.filteredList.length == 0 || this.state.filter == '') ? -1 : 0;
        this.update();
      },

      handleCheckChange(e) {
        if (!this.props.unselectable || e.target.checked) {
          const value = e.target.value;
          this.props.onChange(value);
        } else {
          this.props.onChange('');
        }
        this.update();
        this.closeMenu();
      },

      openMenu(e) {
        this.state.filteredList = this.props.itemList;
        this.state.filter = '';
        this.state.focusedIndex = -1;
        this.state.menu = e.currentTarget;
        this.update();
        if (!this.isTablet) {
          const inputBar = this.$('.menu-search input[type=text]');
          inputBar.focus();
          inputBar.addEventListener('keydown', this.onKeyDown);
        }
      },

      closeMenu() {
        this.state.menu = null;
        this.state.filter = '';
        this.state.filteredList = this.props.itemList;
        this.state.focusedIndex = -1;
        this.$('.menu-search input[type=text]').removeEventListener('keydown', this.onKeyDown);
        this.update();
      },

      getCurrentLabel() {
        const currentItem = this.props.itemList.find(item => {
          return this.props.getId(item) == this.props.value;
        });
        return currentItem ? this.props.getLabel(currentItem) : '';
      },
    };
  </script>
  <style>
    .form-control-search {
      background-color: #ffffff;
      border: 1px solid #b6b6b6;
      border-radius: 4px;
      height: 32px;
      padding: 4px 6px;
      width: 100%;
    }

    .menu-search {
      background-color: #ffffff;
      position: sticky;
      top: 0;
      box-shadow: 0px 0px 4px rgb(0, 0, 0, .6);
      padding: 4px !important;
      height: 40px;
    }

    .menu-item.focus {
      background-color: #f0f0f0;
    }

    .ng-option {
      color: #999;
    }

    .menu-item {
      height: 50px;
    }

    .menu {
      scroll-padding-block-start: 40px;
    }
  </style>
</search-select>